module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABFSURBVDiNY2CgJfj//7/D////G6hhUMN/CKDMMKiL/lPTsP1UMQxq4Eg3jIli06npmiFmCFUSJNWyCNUyLcxVFBtCDgAAgJeooXBBav0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/arrow-right.png
// module id = XRqo
// module chunks = 0